import React, { useContext } from 'react';

import { ProductInfoContext } from '../../../templates/pdp';
import { FAQSection } from '../../../components/PDP/FAQSection';
import ewAnalytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';

export interface FAQContainerProps {
  content: {
    title: string;
  };
}
export const FAQContainer: React.FC<FAQContainerProps> = ({ content }) => {
  const { digDeeperSections } = useContext(ProductInfoContext);

  const handleFAQClick = (question: string) => () => {
    ewAnalytics.track({
      event: ANALYTICS.EVENTS.FAQ_CLICK,
      data: { question },
    });
  };

  if (!digDeeperSections || !content) return null;
  const { title } = content;

  const props = {
    faqs: digDeeperSections,
    title,
    handleFAQClick,
  };

  return <FAQSection {...props} />;
};

export default FAQContainer;
